import {Image, UnstyledButton} from "@mantine/core";
import React from "react";
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import {useMediaQuery} from "@mantine/hooks";
import {ReadMoreNoLink} from "@/app/(index)/read-more";
import cx from "clsx";


interface IProps {
    name: string;
    summary: string;
    link: string;
    image: string;
}

const ResourceCard: React.FC<IProps> = ( { name, summary, link, image} ) => {
    const { fontSize, lang } = useGlobalStateStore();
    const mediaQueryLessSM = useMediaQuery('(min-width: 480px)');
    return (
        <UnstyledButton component="a" target="_blank" href={`${link}`}>
            <div className={cx("flex gap-[30px] justify-between group py-[20px] border-b border-gray-400 border-dotted", mediaQueryLessSM ? "flex-row" : "flex-col")}>

                {
                    mediaQueryLessSM && (
                        <div className="flex">
                            <div className="flex flex-col">
                                <div className={"text-[#158a83] font-bold group-hover:text-black text-[26px] mb-[15px]"}>
                                    { name }
                                </div>
                                <div className={"text-[#333] text-[17px] break-all mb-[25px] text-justify line-clamp-3"}>
                                    { summary }
                                </div>

                                <ReadMoreNoLink name={lang == "tw" ? "閱讀更多" : "read more"}/>
                            </div>
                        </div>
                    )
                }



                <div className={cx(mediaQueryLessSM ? "min-w-[418px]" : "w-full")}>
                    <Image src={`${process.env.NEXT_PUBLIC_API_HOST}/image/${image}`} h={237} w={"auto"} radius={20} className="border border-[#abd0cb]"/>
                </div>

                {
                    !mediaQueryLessSM && (
                        <div className="flex">
                            <div className="flex flex-col">
                                <div className={"text-[#158a83] font-bold group-hover:text-black text-[26px] mb-[15px]"}>
                                    { name }
                                </div>
                                <div className={"text-[#333] text-[17px] break-all mb-[25px] text-justify"}>
                                    { summary }
                                </div>

                                <ReadMoreNoLink/>
                            </div>
                        </div>
                    )
                }

            </div>
        </UnstyledButton>
    );
}

export default ResourceCard;
